import React from 'react';

export const Layout = React.lazy(() => import('./Layout/Layout'));
export const Login = React.lazy(() => import('./Login/Login'));
export const Register = React.lazy(() => import('./Register/Register'));
export const ForgotPassword = React.lazy(
  () => import('./ForgotPassword/ForgotPassword')
);
export const Dashboard = React.lazy(() => import('./Dashboard/Dashboard'));
export const EnvFlag = React.lazy(() => import('./EnvFlag/EnvFlag'));
